import { createSyncStoragePersister } from '@tanstack/query-sync-storage-persister'
import { QueryClient } from '@tanstack/react-query'
import { removeOldestQuery } from '@tanstack/react-query-persist-client'
import throttle from 'lodash/throttle'

export interface CustomQueryMeta {
  persist?: boolean
}

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnMount: true,
      refetchOnReconnect: true,
      refetchOnWindowFocus: true
    }
  }
})

export const localStoragePersister = createSyncStoragePersister({
  storage: window.localStorage,
  retry: removeOldestQuery,
  throttleTime: 100, // 100ms
  serialize: (data: any) => {
    data.clientState.queries = data.clientState.queries.filter(
      (query: any) => (query.meta as CustomQueryMeta)?.persist !== false
    )
    return JSON.stringify(data)
  }
})

export class QueryKeys {
  public static Sessions = ['Sessions']
  public static User = ['User']
  public static OrgUsers = ['OrgUsers']
  public static Conversations = ['Conversations']
  public static Organizations = ['Organizations']
  public static Indexes = ['Indexes']
  public static AgentStatus = ['AgentStatus']
  public static AnnotationTasks = ['AnnotationTasks']
  public static MfaCode = ['MfaCode']
  public static InvitationLink = ['InvitationLink']
  public static FlowNames = ['FlowNames']
  public static OrgRepos = ['OrgRepos']
  public static AccessLogs = ['AccessLogs']
  public static SignupsCSV = ['SignupsCSV']
  public static UserActivitiesCSV = ['UserActivitiesCSV']
  public static CampaignAgentType = ['CampaignAgentType']
  public static DomainList = ['DomainList']
  public static EDITransactionCodes = ['EDITransactionCodes']
  public static EDIFactCodes = ['EDIFactCodes']
  public static BillingInfo = ['BillingInfo']
  public static DomainEmailList = ['DomainEmailList']
  public static AdminWorkspaceList = ['AdminWorkspaceList']
  public static AdminConversationList = ['AdminConversationList']
  public static AccountBillingType = ['AccountBillingType']
  public static TrialStatus = ['TrialStatus']
  public static PaymentDetails = ['PaymentDetails']
  public static FeatureFlags = ['FeatureFlags']
  public static AccountBillingInfo = ['AccountBillingInfo']
}

export const throttedInvalidateConversations = throttle(() => {
  return queryClient.invalidateQueries(
    { queryKey: QueryKeys.Conversations },
    { cancelRefetch: true }
  )
}, 500)
